export const TipoCuentaEnum = {
  ACOMETIDAS_BT_INDIVIDUALES: { id: 1, nombre: 'Acometidas BT individuales' },
  CINCO_O_MAS_ACOMETIDAS_BT: { id: 2, nombre: 'Cinco o mas acometidas en BT' },
  PROYECTOS_EXPANSION: { id: 3, nombre: 'Proyectos con expansión de Redes y transformadores' },
  CUENTA_TRIFASICA_BT: { id: 6, nombre: 'Cuenta trifásica en baja tensión' },
  GESTION_ELECTROHUILA: { id: 10, nombre: 'Gestión Electrohuila S.A E.S.P' },
  PROVISIONAL_OBRA: { id: 15, nombre: 'Provisional de Obra' },
  PARAMETRIZACION_MEDIDORES: { id: 17, nombre: 'Parametrización Medidores' },
  CUENTA_NUEVA_FUTURO_AGPE: { id: 16, nombre: 'Cuenta nueva para futuro AGPE' },
  LEGALIZACION_RED_BT: { id: 14, nombre: 'Legalización para red de BT' },
};
